(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[672],{

/***/ 77979:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/forgotten-password",
      function () {
        return __webpack_require__(26385);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 26385:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(43692);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(44453);
/* harmony import */ var _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(8014);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1984);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(56168);
/* harmony import */ var next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62044);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75332);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var _components_Layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46323);
/* harmony import */ var _helpers__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(17651);
/* harmony import */ var enums__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(39933);
/* harmony import */ var _api_client__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(66564);
/* harmony import */ var _login_index_module_scss__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(6054);
/* harmony import */ var _login_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default = /*#__PURE__*/__webpack_require__.n(_login_index_module_scss__WEBPACK_IMPORTED_MODULE_14__);
/* harmony import */ var helpers_jsx__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(28808);
/* harmony import */ var context__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(52662);
/* harmony import */ var context_langContext__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(70082);















var ForgottenPassword = function(param) {
    var countryCode = param.countryCode;
    var auth = (0,context__WEBPACK_IMPORTED_MODULE_11__/* .useAuth */ .aC)();
    var t = (0,next_translate_useTranslation__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(enums__WEBPACK_IMPORTED_MODULE_8__/* .Namespace.ForgottenPassword */ .lS.ForgottenPassword).t;
    var createNotification = (0,context__WEBPACK_IMPORTED_MODULE_11__/* .useNotificationContext */ .nw)().createNotification;
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var serverError = (0,react__WEBPACK_IMPORTED_MODULE_3__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var locale = (0,context_langContext__WEBPACK_IMPORTED_MODULE_12__/* .useLang */ .J)().locale;
    var RULE_NOT_EMPTY = t("common:form.not_empty");
    var RULE_WRONG_EMAIL = t("common:form.email_format");
    var onSubmit = (0,react__WEBPACK_IMPORTED_MODULE_3__.useCallback)(function() {
        var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z)(_opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee(event) {
            var formSchema, email, validateObject, valid;
            return _opt_atlassian_pipelines_agent_build_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        event.preventDefault();
                        event.stopPropagation();
                        formSchema = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .createFormSchema */ .ZS)({
                            email: (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .emailRule */ .$D)(RULE_WRONG_EMAIL, RULE_NOT_EMPTY)
                        });
                        email = event.target.email.value;
                        validateObject = {
                            email: email
                        };
                        valid = (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .validateForm */ .G$)(formSchema, validateObject, ref.current);
                        if (!valid) {
                            _ctx.next = 21;
                            break;
                        }
                        _ctx.prev = 7;
                        _ctx.next = 10;
                        return (0,_api_client__WEBPACK_IMPORTED_MODULE_9__/* .getSharedApiClient */ .L)().resetPassword(email);
                    case 10:
                        router.push(_helpers__WEBPACK_IMPORTED_MODULE_7__/* .Permalink.root */ .xm.root(null, locale));
                        createNotification({
                            title: t("changes_saved")
                        });
                        _ctx.next = 19;
                        break;
                    case 14:
                        _ctx.prev = 14;
                        _ctx.t0 = _ctx["catch"](7);
                        (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(ref.current);
                        createNotification({
                            title: t("changes_not_saved")
                        });
                        serverError.current.innerHTML = t("server_error");
                    case 19:
                        _ctx.next = 22;
                        break;
                    case 21:
                        {
                            (0,_helpers__WEBPACK_IMPORTED_MODULE_7__/* .resetForm */ .Fx)(ref.current);
                        }
                    case 22:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    7,
                    14
                ]
            ]);
        }));
        return function(event) {
            return _ref.apply(this, arguments);
        };
    }(), [
        auth
    ]);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_components_Layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
        countryCode: countryCode,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
                children: (0,helpers_jsx__WEBPACK_IMPORTED_MODULE_10__/* .basicSEO */ .F)(t("seo:forgotten_password_title"), t("seo:forgotten_password_description"))
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("main", {
                className: (_login_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().login),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("div", {
                    className: (_login_index_module_scss__WEBPACK_IMPORTED_MODULE_14___default().loginWrapper),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                            children: t("title")
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("form", {
                            ref: ref,
                            onSubmit: onSubmit,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("label", {
                                    children: [
                                        t("email"),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("input", {
                                            type: "text",
                                            placeholder: t("email_placeholder"),
                                            name: "email",
                                            id: "email"
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {})
                                    ]
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("button", {
                                    type: "submit",
                                    className: "btn btn-primary",
                                    children: t("btn")
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("label", {
                                    ref: serverError,
                                    className: "server-error",
                                    id: "server-error",
                                    htmlFor: "email"
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
var __N_SSP = true;
/* harmony default export */ __webpack_exports__["default"] = (ForgottenPassword);


/***/ }),

/***/ 6054:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"login":"login_login__nnXkC","loginWrapper":"login_loginWrapper__RKEmS"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [9774,2888,179], function() { return __webpack_exec__(77979); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);